// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin: 0;
}
.grid.filters {
  grid-template-columns: repeat(5, auto);
}
.grid.screenings {
  grid-template-columns: repeat(10, auto);
}
.grid.screenings.cra {
  grid-template-columns: repeat(11, auto);
}
.grid.screenings > div:nth-child(24n+13),
.grid.screenings > div:nth-child(24n+14),
.grid.screenings > div:nth-child(24n+15),
.grid.screenings > div:nth-child(24n+16),
.grid.screenings > div:nth-child(24n+17),
.grid.screenings > div:nth-child(24n+24),
.grid.screenings > div:nth-child(24n+19),
.grid.screenings > div:nth-child(24n+20),
.grid.screenings > div:nth-child(24n+21),
.grid.screenings > div:nth-child(24n+22),
.grid.screenings > div:nth-child(24n+23),
.grid.screenings > div:nth-child(24n+24) {
  background-color: rgba(245, 245, 245, 0.3);
}
.header-selected {
  color: #000;
  background-color: #c1bffb;
}
.dispute-indicator {
  margin-left: 8px;
  cursor: help;
  font-size: 16px;
}
.income-received-indicator {
  margin-left: 6px;
  cursor: help;
  font-size: 14px;
  color: #0d6efd;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/screening-list/screening-list.component.less"],"names":[],"mappings":"AAEA;EACI,SAAA;AADJ;AAGA;EACI,sCAAA;AADJ;AAGA;EACI,uCAAA;AADJ;AAGA;EACI,uCAAA;AADJ;AAGA;;;;;;;;;;;;EAYE,0CAAA;AADF;AAIA;EACI,WAAA;EACA,yBAAA;AAFJ;AAIA;EAEI,gBAAA;EACA,YAAA;EACA,eAAA;AAHJ;AAKA;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAHJ","sourcesContent":["@import (reference) url(\"../../../styles.less\");\n\nh1 {\n    margin: 0;\n}\n.grid.filters {\n    grid-template-columns: repeat(5, auto);\n}\n.grid.screenings {\n    grid-template-columns: repeat(10, auto);\n}\n.grid.screenings.cra {\n    grid-template-columns: repeat(11, auto);\n}\n.grid.screenings > div:nth-child(24n+13),\n.grid.screenings > div:nth-child(24n+14),\n.grid.screenings > div:nth-child(24n+15),\n.grid.screenings > div:nth-child(24n+16),\n.grid.screenings > div:nth-child(24n+17),\n.grid.screenings > div:nth-child(24n+24),\n.grid.screenings > div:nth-child(24n+19),\n.grid.screenings > div:nth-child(24n+20),\n.grid.screenings > div:nth-child(24n+21),\n.grid.screenings > div:nth-child(24n+22),\n.grid.screenings > div:nth-child(24n+23),\n.grid.screenings > div:nth-child(24n+24) {\n  background-color: @grid-row;\n}\n\n.header-selected{\n    color: #000;\n    background-color: #c1bffb;\n}\n.dispute-indicator {\n    //color: #dc3545;\n    margin-left: 8px;\n    cursor: help;\n    font-size: 16px;\n}\n.income-received-indicator {\n    margin-left: 6px;\n    cursor: help;\n    font-size: 14px;\n    color: #0d6efd;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
